// NOTE: esbuild移行の一環として、基本的に過去の仕様をそのままコピペしている
// (拡散ページではフォローボタンがページトップにあるためスクロールリスナーは必要なく、パフォーマンス観点で改善余地あり、
// また#jsSnsFollowをフックにしているが、厳密には「いいねボタン」のため命名修正も推奨される)

function initializeFacebookLikeButton(facebookUrl) {
  if (!facebookUrl) return;

  if (!document.getElementById("facebook-jssdk")) {
    const fjs = document.getElementsByTagName("script")[0];
    const js = document.createElement("script");
    js.id = "facebook-jssdk";
    js.src =
      "https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.8&appId=650509631817471";
    fjs.parentNode.insertBefore(js, fjs);
  } // NOTE: headにもこのfaebookのsdkが含まれている仕様のため、どちらかに統一することを推奨

  const fbBtnHtml = `
    <div class="fb-like"
       data-href="${facebookUrl}"
       data-layout="button_count"
       data-action="like"
       data-size="small"
       data-show-faces="true"
       data-share="false">
    </div>
  `;

  let buttonAppended = false;

  const appendButton = () => {
    const container = $("#jsSnsFollow");
    if (!container.length || buttonAppended) return;

    container.append(fbBtnHtml);
    buttonAppended = true;

    if (window.FB) {
      FB.XFBML.parse();
    }
  };

  appendButton();

  $(window).on("scroll", appendButton);
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeFacebookLikeButton;